// Posisi step granular onboarding disimpan per perusahaan di localStorage (resume presisi
// di device yang sama). Backend hanya menyimpan milestone bisnis di option finance_onboarding
// (4 nilai: new/invoice_created/whatsapp_sent/profit_loss_viewed — lihat financeOnboardingSlice.js).
// Disimpan bersama path halaman step supaya membuka tab baru / reload di halaman lain
// bisa langsung diarahkan ke halaman step terakhir.
const keyFor = (endpoint) => `kledo_finance_onboarding_step_${endpoint || 'default'}`

export const loadStep = (endpoint) => {
  try {
    const raw = window.localStorage.getItem(keyFor(endpoint))
    if (!raw) {
      return null
    }
    // Kompatibilitas nilai lama yang hanya menyimpan string step polos.
    if (raw.charAt(0) !== '{') {
      return { step: raw, path: null }
    }
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export const saveStep = (endpoint, step, path) => {
  try {
    window.localStorage.setItem(keyFor(endpoint), JSON.stringify({ step, path: path || null }))
  } catch (e) {
    // storage tidak tersedia (private mode), abaikan
  }
}

export const clearStep = (endpoint) => {
  try {
    window.localStorage.removeItem(keyFor(endpoint))
  } catch (e) {
    // abaikan
  }
}

// Status "Nanti saja": step & halaman terakhir saat panduan ditunda. Selama ada, reload tidak
// memunculkan panduan lagi sampai user melanjutkannya lewat widget di sidebar.
const snoozeKeyFor = (endpoint) => `kledo_finance_onboarding_snooze_${endpoint || 'default'}`

export const loadSnooze = (endpoint) => {
  try {
    const raw = window.localStorage.getItem(snoozeKeyFor(endpoint))
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export const saveSnooze = (endpoint, step, path) => {
  try {
    window.localStorage.setItem(
      snoozeKeyFor(endpoint),
      JSON.stringify({ step, path: path || null }),
    )
  } catch (e) {
    // storage tidak tersedia (private mode), abaikan
  }
}

export const clearSnooze = (endpoint) => {
  try {
    window.localStorage.removeItem(snoozeKeyFor(endpoint))
  } catch (e) {
    // abaikan
  }
}
